import styled from 'styled-components'
import { BP } from 'resources/constants'
import { buttonSecondary } from 'app/sofia/resources/theme/css'

export const ReviewHeader = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;

  .rating__action {
    button {
      ${buttonSecondary};
      width: 100%;

      @media (min-width: ${BP.xs.min}) {
        width: auto;
      }
    }
  }
`

export const Summary = styled.div`
  text-align: center;
  padding: 15px;
  margin-top: 10px;
  background: ${props => props.theme.palette.primary.alphaLight};

  @media (min-width: ${BP.sm.min}) {
    margin-top: 20px;
    padding: 25px;
  }

  .rating__average {
    > div {
      justify-content: center;
    }

    h4 {
      display: block;
      margin-bottom: 3px;
    }

    p {
      color: ${props => props.theme.palette.general.headerColor};
      margin: 10px 0 0;
      line-height: 1;
    }

    > p {
      margin-bottom: 15px;
    }

    .react-rater-star {
      width: 22px;
      height: 22px;
      background-size: 22px;

      @media (min-width: ${BP.sm.min}) {
        width: 32px;
        height: 32px;
        background-size: 32px;
      }
    }
  }
`
